import controller from './send-mail.controller';

const template = require('./send-mail.html');

export default {
    bindings: {
        action: '<',
        onClose: '&'
    },
    template,
    controller
};



// WEBPACK FOOTER //
// ./app/components/alerts-actions/alerts-actions-content/actions/send-mail/send-mail.component.js